import { api } from '../middleware/api';
import { sseClient } from '../../services/sseClient';

// Define endpoints using injectApi pattern
export const poebillApi = api
  .enhanceEndpoints({ addTagTypes: ['POEBill'] })
  .injectEndpoints({
    endpoints: builder => ({
      getPOEBills: builder.query<(po_ebill & po_mtable & em_memployee)[], any>({
        query: ({ cid, bid }) => `poebill/bycb/${cid}/${bid}`,
        providesTags: ['POEBill'],
        async onCacheEntryAdded(
          _arg,
          { cacheDataLoaded, cacheEntryRemoved, dispatch }
        ) {
          try {
            await cacheDataLoaded;
            const unsubscribe = sseClient.addListener(data => {
              if (
                data.type === 'POS_ORDER_UPDATED' ||
                data.type === 'POS_BILL_UPDATED'
              ) {
                dispatch(poebillApi.util.invalidateTags(['POEBill']));
              }
            });
            await cacheEntryRemoved;
            unsubscribe();
          } catch {
            // no-op
          }
        }
      }),
      getPOEBillByTable: builder.query<any[], any>({
        query: ({ cid, tbl }) => `poebill/${cid}/${tbl}`,
        providesTags: ['POEBill']
      }),
      getPOEBillById: builder.query<any, string>({
        query: id => `poebill/byid/${id}`,
        providesTags: ['POEBill']
      }),
      getPOEBillByBill: builder.query<any, string>({
        query: id => `poebill/bybill/${id}`,
        providesTags: ['POEBill']
      }),
      insertPOEBill: builder.mutation({
        query: poebill => ({
          url: `poebill/`,
          method: 'POST',
          body: poebill
        }),
        invalidatesTags: ['POEBill']
      }),
      updatePOEBill: builder.mutation({
        query: poebill => ({
          url: `poebill/`,
          method: 'PUT',
          body: poebill
        }),
        invalidatesTags: ['POEBill']
      }),
      update2POEBill: builder.mutation({
        query: poebill => ({
          url: `poebill/update`,
          method: 'PUT',
          body: poebill
        }),
        invalidatesTags: ['POEBill']
      }),
      deletePOEBill: builder.mutation({
        query: poebill => ({
          url: `poebill/${poebill.bl_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['POEBill']
      })
    }),
    overrideExisting: true
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPOEBillsQuery,
  useGetPOEBillByTableQuery,
  useGetPOEBillByIdQuery,
  useGetPOEBillByBillQuery,
  useInsertPOEBillMutation,
  useUpdatePOEBillMutation,
  useUpdate2POEBillMutation,
  useDeletePOEBillMutation
} = poebillApi;

